module.exports = __webpack_public_path__ + "media/images/pc/brands/sola/store_hokkaido@2x-560cbe528f2a5c081ef07692eea2e8c6.webp";